/* global ga, NProgress */
Wee.fn.make('common', {
	init: function() {
		var priv = this.$private,
			loadTimer;

		NProgress.configure({
			showSpinner: false
		});

		// Wee history
		$.history.init({
			bind: {
				click: 'a'
			},
			request: {
				send: function() {
					NProgress.start();

					loadTimer = setInterval(function() {
						NProgress.inc();
					}, 600);
				},
				success: function() {
					ga('send', 'pageview');
				},
				complete: function() {
					clearInterval(loadTimer);

					NProgress.done();
				},
				error: function(xhr) {
					$._win.location = xhr.responseURL;
				}
			}
		});

		// Disable mouse event outlines
		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';

				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: $._body
		});

		priv.initCart();
	}
}, {
	/**
	 * Init cart
	 *
	 * @private
	 */
	initCart: function() {
		$.view.addHelper('plural', function() {
			return this.val > 1;
		});

		$.fetch.request({
			url: '/cart.json',
			json: true,
			success: function(response) {
				var cart = response.data;

				if (cart.length) {
					$.set('cart', cart[0]);
				}
			}
		});

		Wee.commerce.init({
			onChange: function(cart) {
				var $body = $(Wee._body);

				if ($('ref:cart').length) {
					var template = 'Shopping Cart{{ #isEmpty|is(false) }} ({{ totalQty }} Item{{ totalQty|plural() ? "s" : "" }}){{ /isEmpty }}';

					$('ref:cartTitle').html($.view.render(template, cart));

					if (cart.isEmpty) {
						$('ref:cartActions').hide();
						$('ref:cartEmptyContent').show();

						$body.tween({
							scrollTop: $body.offset().top
						});
					}
				}
			}
		});
	}
});